export default __webpack_public_path__ + "static/media/bedroom-6.7a134b56.png";